<template>
    <b-row>
        <b-col lg="10" sm="10" md="10">
            <div class="animated fadeIn">
                <div class="alert alert-danger" v-if="!validNutritionist"> <b> {{ $t('profile.data_missing') }} </b> </div>
                <ProfileFormComponent v-if="!!getUser" :form="form" :user="user" :validNutritionist="validNutritionist"></ProfileFormComponent>
                <b-row>
                    <b-col>
                        <b-card>
                            <div slot="header">
                                <strong>{{user.username}} {{ $t('profile.account_image') }}</strong>
                            </div>
                            <b-form @submit="upload($event)">
                                <div>
                                    <img width="50px" height="50px" v-if="!!getUser.image" :src="url+getUser.image" alt="">
                                    <img v-if="!getUser.image" src="../assets/img/avatars/6.jpg" alt="">
                                </div>
                                <br>
                                <div>
                                    <input type="file" ref="file" name="image" accept="image/png, image/jpg, image/jpeg">
                                    <span v-if="image_error != null" style="color: red;font-weight: bold;font-size: 16px;">{{ image_error }}</span>
                                </div>
                                <br>
                                <div slot="footer">
                                    <b-button type="submit" size="md" variant="primary"><i class="fa fa-dot-circle-o"></i> {{ $t('profile.upload_image') }}</b-button>
                                    <br><br>
                                    <p v-if="image_error != null" style="font-size: 18px;">{{ $t("profile.image_tip") }}</p>
                                </div>
                            </b-form>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>

<script>

import ProfileFormComponent from '@/components/ProfileForm';
import Models from '@/store/ORM/models.js';
import ProfileService from '@/services/profile.service.js';
import Nutritionist from '@/store/ORM/nutritionists.js';
import * as constants from '../helpers/Constants.js'

export default {
    name: 'dashboard',
    components: {
        ProfileFormComponent
    },
    data: function () {
        return {
            form: {},
            image: null,
            url : constants.APIURL,
            user : this.$store.state['UserModules'].user,
            image_error: null
        }
    },
    methods: {
        upload(evt){

            evt.preventDefault();

            let formData = new FormData();
            formData.append('image',this.$refs.file.files[0]);

            ProfileService.uploadImage(this.getUser.id,formData).then(res=>{

                if(res.data.error != undefined) {
                    this.image_error = this.$t('profile.max_image');
                } else {
                    this.image_error = null;
                }

                Nutritionist.update({
                    where: this.getUser.id,
                    data: {
                        image: res.data.nutritionist.image,
                    }
                });

                this.$toastr.success(this.$i18n.t('profile.pofile_image_updated'), this.$i18n.t('profile.pofile_image_updated'));
            });
        },
    },
    created(){
        this.form = {
            first_name: this.getUser.first_name,
            last_name: this.getUser.last_name,
            identification: this.getUser
            .identification,
            sex: this.getUser.sex,
            address: this.getUser.address,
            phone_number: this.getUser
            .phone_number,
            dob: this.getUser.dob,
            email: this.getUser.email,
            whatsapp_nr: this.getUser.whatsapp_nr,
            id: this.getUser.id,
            can_show: this.getUser.can_show,
            created_at: this.getUser.created_at.split('T')[0],
        };
    },

    computed: {
        getUser(){
            return Models.Nutritionist.query().first();
        },

        validNutritionist: function(){

            let nut = Nutritionist.query().where('id', this.getUser.id).first();

            if(!!nut.address && !!nut.email && !!nut.first_name && !!nut.last_name && !!nut.sex){

                return true;
            }

            return false;
        },
    },
}
</script>

<style>
    /* IE fix */
    #card-chart-01, #card-chart-02 {
        width: 100% !important;
    }
</style>
